var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout-top-right"},[_c('cart-button-control'),_c('div',{staticClass:"main-layout-top-right__user",on:{"click":_vm.logout}},[_c('svg-icon',{attrs:{"iconId":"logout"}}),_c('span',[_vm._v("Log Out")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }